import { Directive } from '@angular/core';
export class UploadImageDirective {
constructor() { }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[hdUploadImage]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UploadImageDirective_tsickle_Closure_declarations() {
/** @type {?} */
UploadImageDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UploadImageDirective.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
